import { render, staticRenderFns } from "./BuildingShowIssuesTab.vue?vue&type=template&id=7b01dcad"
import script from "./BuildingShowIssuesTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowIssuesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports